import {RestResource} from '../rest'
import {NOTICE_SERVER} from '../server'
import {athubAxios} from "@/util";

const deptExtendInfo = new RestResource({server: NOTICE_SERVER, resource: 'deptExtendInfo'});

deptExtendInfo.list = () => {
    return athubAxios.get(`${NOTICE_SERVER}/deptExtendInfo/list`);
};

deptExtendInfo.update = (data) => {
    return athubAxios.put(`${NOTICE_SERVER}/deptExtendInfo`, data);
};

export default deptExtendInfo;